import { axiosInstance } from "@hopper-b2b/api";
import { FlightKey } from "@b2bportal/air-price-watch-api";
import {
  airShoppingApi,
  Platform,
  ShopFilter,
  ShopSummaryRequest,
} from "@b2bportal/air-shopping-api";
import { useDeviceType } from "@b2bportal/core-utilities";

/**
 * A hook that returns a function that calls shopSummary API with ShopFilter
 *
 * Calling shopSummary with the specific filter(s) is required in the backend
 * in order to create a flight price watch with those filters
 *
 * TODO(fyoshimatsu): This is probably doing price-watch incorrectly.
 * How the backend API was implemented suggests that these filters should _not_
 * independently applied to a price-watch at the time of creating the price-watch.
 * Rather, it is implied that the user searches for flights (via shopSummary API)
 * first with those filters, then call the API to create a price-watch for that
 * particular search. Our UI atm doesn't allow to do that (filtering happens
 * entirely in the FE after calling fetchFlights) that may need to be revisited.
 */
export const useFetchFlightsForPriceWatch = () => {
  const { isDesktopAndUp } = useDeviceType();
  return (params: {
    flightKey: FlightKey;
    passengers: { [key: string]: number };
    shopFilter?: ShopFilter;
  }) => {
    const { flightKey, passengers, shopFilter } = params;
    const { origin, destination, departureDate, returnDate } = flightKey.value;
    const requestBody: ShopSummaryRequest = {
      passengers,
      route: {
        origin,
        destination,
      },
      tripFilter: shopFilter ?? ShopFilter.NoFilter,
      platform: isDesktopAndUp ? Platform.Desktop : Platform.Mobile,
      departureDate,
      ...(returnDate == null ? {} : { returnDate: returnDate }),
    };

    return airShoppingApi(axiosInstance).apiV4ShopSummaryPost(requestBody);
  };
};
